import { render, staticRenderFns } from "./CloseView.vue?vue&type=template&id=4dfeb300&scoped=true"
var script = {}
import style0 from "./CloseView.vue?vue&type=style&index=0&id=4dfeb300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfeb300",
  null
  
)

export default component.exports